module.exports = __webpack_public_path__ + "static/media/avatar.06ab88c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/About/avatar.jpg
// module id = 1134
// module chunks = 0